import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { Timestamp } from "firebase/firestore";
import { parse } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function arrayUnion<T>(value: T, array: T[]) {
  return [...array.filter((item) => item !== value), value];
}

export function arrayRemove<T>(value: T, array: T[]) {
  return [...array.filter((item) => item !== value)];
}

export function firestoreToDateTime(
  firestoreTime: Timestamp | Date | undefined | null | string
) {
  if (!firestoreTime) {
    return undefined;
  }
  if (typeof firestoreTime === "string") {
    return parse(firestoreTime, "yyyy-MM-dd", new Date());
  }
  if (firestoreTime instanceof Date) return firestoreTime;
  return firestoreTime?.toDate();
}

export function getNextLetter(str: string): string | null {
  if (!str || str.length === 0) return null;

  const firstChar = str.charAt(0); // Get the first character
  const charCode = firstChar.charCodeAt(0); // Get the character code (ASCII/Unicode)

  // Check if it's a letter
  if (charCode >= 65 && charCode <= 90) {
    // A-Z
    return String.fromCharCode(charCode + 1 <= 90 ? charCode + 1 : 65); // Wrap to 'A' if 'Z'
  } else if (charCode >= 97 && charCode <= 122) {
    // a-z
    return String.fromCharCode(charCode + 1 <= 122 ? charCode + 1 : 97); // Wrap to 'a' if 'z'
  } else {
    return null; // Not a letter
  }
}
